import { useEffect, useMemo, useRef, useState } from "react"
import { SiteVideoInline } from "../../../../siteWidgets/videoPlayer/genericInlineVideoPlayer/siteVideoInline"
import { LiveVideoPlayer } from "../../liveVideoPlayer/components/liveVideoPlayer"
import { SiteVideoData } from "../../../../interfaces"
import { isWcmEditor } from "../../../../../config/serverConfig"
import { videoSourceOption } from "../../../topStory/windows/contentWindow/videoLiveSourceSelector"

interface StripLivePlayerStripProps {
    videoTitle: string
    videoAutoPlay: boolean
    videoMuteSound: boolean
    videoShowSoundBtn: boolean
    liveIndicationText: string
    videoShowControlPanel: boolean
    liveVideoSource: videoSourceOption
    isMobileWeb?: boolean
    videoLiveLocation?: string
}

export const StripLivePlayerStrip = (props: StripLivePlayerStripProps) => {

    const { videoTitle, videoAutoPlay, videoMuteSound, liveVideoSource, videoShowSoundBtn, videoShowControlPanel, liveIndicationText, isMobileWeb, videoLiveLocation } = props
    const [isFloatingPlayerVisible, setIsFloatingPlayerVisible] = useState(false)
    const playerRef: any = useRef<any>(null)
    const isFirstPlay: any = useRef<boolean>(true)

    const flowPlayerData: SiteVideoData = useMemo(() => {
        return {
            mediaType: "MEDIA_VIDEO",
            url: liveVideoSource.lowResSrc,
            fullScreenUrl: liveVideoSource.src,
            mediaId: "",
            poster: "",
            youtube_id: "",
            isLive: true,
            isMuteAvailable: true,
            blockAbroadViews: false,
            isSoundButtonVisible: videoShowSoundBtn,
            isPlayerBarVisible: videoShowControlPanel,
            isAutoPlaying: isMobileWeb ? true : videoAutoPlay,
            thisLocation: videoLiveLocation
        }
    }, [liveVideoSource, videoAutoPlay, videoShowControlPanel, videoShowSoundBtn, videoMuteSound])

    const handlePlayerLoaded = (player) => {
        playerRef.current = player;
        player.setOpts({ muted: isMobileWeb ? true : videoMuteSound });
        playerRef.current.addEventListener('pause', handlePlayerPause)
        playerRef.current.addEventListener('play', handlePlayerPlay)
        playerRef.current.addEventListener('volumechange', handleVolumeChange)
    }


    const handlePlayerPlay = () => {
        if (isFirstPlay.current && videoAutoPlay) {
            isFirstPlay.current = false
            return
        }

        setIsFloatingPlayerVisible(true);
    }

    const handlePlayerPause = () => {

    }

    const handleVolumeChange = () => {
        if (!playerRef.current.muted) {
            setIsFloatingPlayerVisible(true);
        }
    }

    const onIsFloatingPlayerVisibleChange = (isOpen: boolean) => {
        setIsFloatingPlayerVisible(isOpen)
    }

    useEffect(() => {
        if (isWcmEditor()) return;

        return () => {
            if (playerRef.current) {
                playerRef.current.removeEventListener('pause', handlePlayerPause)
                playerRef.current.removeEventListener('play', handlePlayerPlay)
                playerRef.current.removeEventListener('volumechange', handleVolumeChange)
            }
        }
    }, [])

    return (
        <div className="strip-live-player-strip 666">
            {isWcmEditor() ?
                <video className="editor-video" src={liveVideoSource.lowResSrc}></video>
                :
                <SiteVideoInline
                    hideVideoAds
                    data={flowPlayerData}
                    isShareButton={false}
                    applyStickyness={false}
                />
            }

            <div className="live-details">
                {/* <img className="live-icon" src={"../../../../../assets/images/dots-wave-loop.gif"} alt="dots wave loop" /> */}

                <div className="live-text">{liveIndicationText}</div>

                <div className="program-title">{videoTitle}</div>
            </div>

            {!isWcmEditor() && isFloatingPlayerVisible &&
                <LiveVideoPlayer
                    videoMuteSound={false}
                    videoTitle={videoTitle}
                    isMobileWeb={isMobileWeb}
                    isMinimizedVisible={false}
                    videoAutoPlay={videoAutoPlay}
                    liveVideoSource={liveVideoSource}
                    videoShowSoundBtn={videoShowSoundBtn}
                    liveIndicationText={liveIndicationText}
                    videoShowControlPanel={videoShowControlPanel}
                    externalIsOpenTrigger={isFloatingPlayerVisible}
                    onExternalIsOpenTriggerChange={onIsFloatingPlayerVisibleChange}
                    thisLocation={"strip"}
                />
            }
        </div>
    )
}

StripLivePlayerStrip.siteScriptName = "StripLivePlayerStrip"